module.exports = __webpack_public_path__ + "img/banner2026m_en.11ec3624.webp";